<template>
  <div>
    <RevButtonBase
      target="_blank"
      :to="getStoreUrl(APPSFLYER_APPLE_STORE_URL)"
      :tracking="{
        name: 'apple_store',
        zone: trackingZone,
      }"
    >
      <RevIllustration
        alt="Apple Store"
        class="inline-block h-64"
        :height="30"
        :src="`/img/socials/${market.countryCode}/apple-store.svg`"
        :width="95"
      />
    </RevButtonBase>

    <RevButtonBase
      target="_blank"
      :to="getStoreUrl(APPSFLYER_GOOGLE_PLAY_URL)"
      :tracking="{
        name: 'google_play_store',
        zone: trackingZone,
      }"
    >
      <RevIllustration
        alt="Google Play"
        class="ml-8 inline-block h-64"
        :height="30"
        :src="`/img/socials/${market.countryCode}/google-play.svg`"
        :width="101"
      />
    </RevButtonBase>
  </div>
</template>

<script lang="ts" setup>
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'

// [LIF-2419] This component has been dupplicated from the global nuxt-layer-base package:
// Here Appsflyer's URLs are differents from the ones stored in environement variables.
// We'll update and sync all the URLs in a future task
const APPSFLYER_APPLE_STORE_URL = 'https://app.backmarket.com/Mlqg/obdy2rt'
const APPSFLYER_GOOGLE_PLAY_URL = 'https://app.backmarket.com/Mlqg/iqkoi7b7'

const props = defineProps<{
  trackingZone: string
}>()

const { market } = useMarketplace()

function getStoreUrl(storeBaseUrl: string) {
  return `${storeBaseUrl}?&af_ad=${market.countryCode.toLowerCase()}&af_adset=${props.trackingZone}`
}
</script>
